import React from 'react';
import { Col, Container, Row, Table } from 'reactstrap';
import { Apify } from '../Apify';
import { connect } from 'react-redux';
import I18N from '../I18N';
import { T } from '../traks';
import { A, R } from '../routes';


var TradeHistory = (props) => {
	var rows = [];
	var stock_delta = "";

	for (const row of props.trade_history) {
		stock_delta = I18N.floatval(row.StockDelta * Math.pow(10, -row.StockNDecimals), row.StockNDecimals);

		var portfolio_href;
		if (row.GameId !== 0) {
			portfolio_href = R.href('/game/:id', {id: row.GameId});
		} else {
			portfolio_href = R.href('/portfolio/:id', {id: row.PortfolioId});
		}

		var stock_href = R.href("/ticker/:exchange/:ticker", {exchange: row.StockExchange, ticker: row.StockTicker});

		rows.push(
			<tr key={row.TransactionId}>
				<td>{row.TransactionId}</td>
				<td>{row.Type}</td>
				<td>{I18N.datetime_short(new Date(row.Ts * 1000))}</td>
				<td><A href={portfolio_href}>{row.PortfolioName}</A></td>
				<td><A href={stock_href}>{row.StockExchange}:{row.StockTicker} ({row.StockName})</A></td>
				<td>{stock_delta}</td>
			</tr>
		);
	}
	return (
		<Container>
			<Row className="py-4">
				<Col xs="12">
					<h2><T>Your trading history</T></h2>
				</Col>
				<Col xs="12" className="font-90">
					<T>Here you can examine your trading history across all portfolios and games.</T>
				</Col>
			</Row>
			<Row>
			</Row>
			<Row className="ad_notification_box pt-3 font-90">
				<Col xs="12">
				<Table bordered striped size="sm">
				<thead>
					<tr>
						<th><T>Transaction id</T></th>
						<th><T>Type</T></th>
						<th><T>Time</T></th>
						<th><T>Portfolio</T></th>
						<th><T>Equity</T></th>
						<th><T>Amount</T></th>
					</tr>
				</thead>
				<tbody>
					{rows}
				</tbody>
				</Table>
				</Col>
			</Row>
			<div className="p-5"/>
		</Container>
	);
}

TradeHistory = Apify("/a/trade_history")
	.with_response_prop("trade_history")
	.wrap(TradeHistory);

export default connect(
	(state) => ({me: state.me})
)((props) => props.me && <TradeHistory me={props.me}/>);



// WEBPACK FOOTER //
// ./src/p/TradeHistory.js